import { keyframes } from "@emotion/react";
import { Box } from "@mui/system";

import { palette } from "theme/palette";

const spin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

// Fallback shown while a lazily-loaded step chunk is being fetched. Unlike the
// global <Loader/> (which renders null unless isGlobalLoading is set), this is
// always visible, so navigating directly to a not-yet-loaded step never shows a
// blank screen. Rendered inside the form area rather than as a full-screen
// overlay; during normal step transitions the global loader typically covers
// this anyway.
export const RouteFallback = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 240,
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          border: `3px solid ${palette.grey}`,
          borderTopColor: palette.accent,
          animation: `${spin} 0.8s linear infinite`,
        }}
      />
    </Box>
  );
};
